import Home from '@/components/frame/Home'

const home = {
  isShow: true,
  index: 11,
  path: '/insurance',
  component: Home,
  redirect: '/insurance/insurance/insuranceHome',
  name: 'insurance',
  isHead: true,
  meta: {
    title: '安责险管理',
    img: require('@/assets/img/bxfw.png')
  },
  children: [
    {
      path: 'insurance',
      component: () => import('@/views/insuranceManager/index'),
      name: 'insuranceManager',
      meta: { title: '保险管理', close: false },
      children: [
        {
          path: 'insuranceHome',
          component: () => import('@/views/insuranceManager/home'),
          name: 'insuranceHome',
          meta: { title: '工作台', next: '/insurance/insurance/service', close: false }
        },
        // 机构管理
        {
          path: 'institution',
          component: () => import('@/views/insuranceManager/institution'),
          name: 'institution',
          meta: { title: '保险机构管理', next: '/insurance/insurance/service', close: false }
        },
        {
          path: 'service',
          component: () => import('@/views/insuranceManager/service'),
          name: 'service',
          meta: { title: '服务机构管理', next: '/insurance/insurance/specialist', close: true }
        },
        {
          path: 'specialist',
          component: () => import('@/views/insuranceManager/specialist'),
          name: 'specialist',
          meta: { title: '专家库', next: '/insurance/insurance/manager', close: true }
        },

        // 投保管理
        {
          path: 'manager',
          component: () => import('@/views/insuranceManager/manager'),
          name: 'manager',
          meta: { title: '保险管理', next: '/insurance/insurance/project', close: true }
        },

        // 事故预防服务管理
        // {
        //   path: 'project',
        //   component: () => import('@/views/insuranceManager/project'),
        //   name: 'project',
        //   meta: { title: '项目管理', next: '/insurance/insurance/set_manager', close: true}
        // },

        // 理赔管理
        {
          path: 'set_manager',
          name: 'set_manager',
          component: () => import('@/views/insuranceManager/set_manager'),
          meta: { title: '理赔管理', next: '/insurance/insurance/complain', close: true }
        },

        // 事故预防
        {
          path: 'accidents',
          name: 'accidents',
          component: () => import('@/views/accidents/index'),
          meta: { title: '事故预防', next: '/insurance/insurance/estimate', close: true}
        },

        // 监督管理
        {
          path: 'complain',
          name: 'complain',
          component: () => import('@/views/insuranceManager/complain'),
          meta: { title: '投诉管理', next: '/insurance/insurance/estimate', close: true }
        },
        {
          path: 'estimate',
          name: 'estimate',
          component: () => import('@/views/insuranceManager/estimate'),
          meta: { title: '服务评估', next: '/insurance/insurance/ins_satisfaction', close: true }
        },
        {
          path: 'ins_satisfaction',
          name: 'ins_satisfaction',
          component: () => import('@/views/insuranceManager/ins_satisfaction'),
          meta: { title: '保险机构满意度', next: '/insurance/insurance/ser_satisfaction', close: true }
        },
        {
          path: 'ser_satisfaction',
          name: 'ser_satisfaction',
          component: () => import('@/views/insuranceManager/ser_satisfaction'),
          meta: { title: '服务机构满意度', next: '/insurance/insurance/situation', close: true }
        },

        // 统计分析
        {
          path: 'situation',
          name: 'situation',
          component: () => import('@/views/insuranceManager/situation'),
          meta: { title: '投保企业统计查询', next: '/insurance/insurance/settlement', close: true }
        },
        {
          path: 'settlement',
          name: 'settlement',
          component: () => import('@/views/insuranceManager/settlement'),
          meta: { title: '理赔统计查询', next: '/insurance/insurance/accident', close: true }
        },
        {
          path: 'accident',
          name: 'accident',
          component: () => import('@/views/insuranceManager/accident'),
          meta: { title: '事故预防服务费用查询', next: '/insurance/insurance/quality', close: true }
        },
        {
          path: 'performance',
          name: 'performance',
          component: () => import('@/views/insuranceManager/performance'),
          meta: { title: '保险公司业绩查询', next: '/insurance/insurance/cost', close: true }
        },
        {
          path: 'cost',
          name: 'cost',
          component: () => import('@/views/insuranceManager/cost'),
          meta: { title: '服务费用统计', next: '/insurance/insurance/quality', close: true }
        },
        {
          path: 'quality',
          name: 'quality',
          component: () => import('@/views/insuranceManager/quality'),
          meta: { title: '抽查评分统计', close: true }
        }
      ]
    }
  ]
}

export default home



// WEBPACK FOOTER //
// ./src/router/modules/insurance.js